// removed by extract-text-webpack-plugin
module.exports = {"buttonwrapper":"buttonwrapper__3CrZA","top":"top__2dX2v","button":"button__IZyqi","icon":"icon__36fQI","plus":"plus__QICsW","minus":"minus__ltf6q"};


//////////////////
// WEBPACK FOOTER
// ./components/gemView/gemZoomControls/scss/zoomcontrols.scss
// module id = bGVC
// module chunks = 0